import React from "react";

export default function MediaDetailsSkelton() {
  return (
    <article className="mb-[40px] mt-[29px] grid animate-pulse grid-cols-12 items-center gap-[40px] px-[30px] 2xl:gap-[30px]">
      {/* Media Thumbnail Skeleton */}
      <section className="col-span-6 xl:col-span-4 2xl:col-span-3">
        <div className="h-[400px] w-full max-w-[350px] rounded-md bg-gray-300"></div>
      </section>

      {/* Media Details Skeleton */}
      <section className="col-span-6 w-full max-w-[350px] xl:col-span-6 2xl:col-span-9">
        <header>
          <div className="h-[30.24px] w-3/4 rounded bg-gray-300"></div>
        </header>
        <div>
          <div className="mt-[30px] h-[17.64px] w-[150px] rounded bg-gray-300"></div>
          <div className="mt-[10px] h-[20.16px] w-1/2 rounded bg-gray-300"></div>
        </div>

        {/* Media Status Skeleton */}
        <div className="mt-[30px]">
          <div className="mb-[20px] h-[17.64px] w-[150px] rounded bg-gray-300"></div>
          <div className="flex flex-row gap-4">
            <div className="h-[17.64px] w-[100px] rounded bg-gray-300"></div>
            <div className="h-[16px] w-[16px] rounded bg-gray-300"></div>
          </div>
          <div className="mt-[10px] flex flex-row gap-4">
            <div className="h-[17.64px] w-[100px] rounded bg-gray-300"></div>
            <div className="h-[16px] w-[16px] rounded bg-gray-300"></div>
          </div>
        </div>

        {/* Checkbox Skeletons */}
        <div className="mt-[30px] flex flex-row items-center gap-4">
          <div className="h-[17.64px] w-[100px] rounded bg-gray-300"></div>
          <div className="h-[16px] w-[16px] rounded bg-gray-300"></div>
        </div>

        <div className="mt-[10px] flex flex-row items-center gap-4">
          <div className="h-[17.64px] w-[100px] rounded bg-gray-300"></div>
          <div className="h-[16px] w-[16px] rounded bg-gray-300"></div>
        </div>
        {/* <div className="mt-[10px] flex flex-row items-center gap-4">
          <div className="h-[17.64px] w-[100px] rounded bg-gray-300"></div>
          <div className="h-[16px] w-[16px] rounded bg-gray-300"></div>
        </div> */}

        {/* Download Button Skeleton */}
        <div className="mt-[92px] h-[48px] w-[200px] rounded-[25px] bg-gray-300"></div>
      </section>
    </article>
  );
}
